
export default {
  props: {
    image: {
      type: Object,
      default: () => ({})
    }
  }
}
